<template>
  <div style="position: relative">
    <!-- Loading Overlay -->
    <v-overlay v-model="activeLoading" class="align-center justify-center" :persistent="true" contained>
      <v-progress-circular color="primary" indeterminate size="32" width="3" />
    </v-overlay>
    <form ref="credit-request" :action="creditRequest" method="post" style="visibility: hidden">
      <div>
        <button type="submit" />
      </div>
      <input type="hidden" id="request_uuid" name="request_uuid" :value="creditRequestRequestUUID" />
      <input type="hidden" id="timestamp" name="timestamp" :value="creditRequestTimestamp" />
      <input type="hidden" id="course_org" name="course_org" :value="creditRequestCourseOrg" />
      <input type="hidden" id="course_num" name="course_num" :value="creditRequestCourseNum" />
      <input type="hidden" id="course_run" name="course_run" :value="creditRequestCourseRun" />
      <input
        type="hidden"
        id="enrollment_timestamp"
        name="enrollment_timestamp"
        :value="creditRequestEnrollmentTimestamp"
      />
      <input
        type="hidden"
        id="course_completion_timestamp"
        name="course_completion_timestamp"
        :value="creditRequestCourseCompletionTimestamp"
      />
      <input type="hidden" id="final_grade" name="final_grade" :value="creditRequestFinalGrade" />
      <input type="hidden" id="user_username" name="user_username" :value="creditRequestUserUsername" />
      <input type="hidden" id="user_email" name="user_email" :value="creditRequestUserEmail" />
      <input type="hidden" id="user_full_name" name="user_full_name" :value="creditRequestUserFullName" />
      <input
        type="hidden"
        id="user_mailing_address"
        name="user_mailing_address"
        :value="creditRequestUserMailingAddress"
      />
      <input type="hidden" id="user_country" name="user_country" :value="creditRequestUserCountry" />
      <input type="hidden" id="signature" name="signature" :value="creditRequestSignature" />
    </form>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import { AjaxLoader } from '../mixins/ajaxLoader';

export default defineComponent({
  mixins: [AjaxLoader],

  computed: {
    creditRequest() {
      return import.meta.env.VITE_CREDIT_REQUEST_URL;
    }
  },

  props: {
    creditRequestRequestUUID: {
      type: String
    },
    creditRequestTimestamp: {
      type: Number
    },
    creditRequestCourseOrg: {
      type: String
    },
    creditRequestCourseNum: {
      type: String
    },
    creditRequestCourseRun: {
      type: String
    },
    creditRequestEnrollmentTimestamp: {
      type: Number
    },
    creditRequestCourseCompletionTimestamp: {
      type: Number
    },
    creditRequestFinalGrade: {
      type: String
    },
    creditRequestUserUsername: {
      type: String
    },
    creditRequestUserEmail: {
      type: String
    },
    creditRequestUserFullName: {
      type: String
    },
    creditRequestUserMailingAddress: {
      type: String
    },
    creditRequestUserCountry: {
      type: String
    },
    creditRequestSignature: {
      type: String
    }
  },

  created() {
    const self = this;

    setTimeout(() => {
      self.$refs['credit-request'].submit();
    }, 1000);
  }
});
</script>

<style></style>
